// extracted by mini-css-extract-plugin
module.exports = {"doc":"about_doc__H2oz3","table":"about_table__Lkdoo","point":"about_point__SH6O0"};